import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Permis de conduire',
  content: [
    'Votre permis de conduire est un document important. Non seulement est-il nécessaire pour conduire un véhicule',
    'automobile, mais il est souvent utilisé pour vérifier votre identité. Suivez les étapes ci-dessous pour remplacer',
    'votre permis de conduire en cas de perte ou de vol :',

    '<h6>Colombie-Britannique</h6>',
    '<ul>',
    '<li>Permis de conduire amélioré (avec photo) : Communiquez immédiatement avec le service à la clientèle du permis',
    'de conduire amélioré au <a  href="tel:+1-866-972-6888">1-866-972-6888</a>. Vous devrez prendre rendez-vous en',
    'personne pour remplacer la carte, et apporter votre certificat de naissance ou votre preuve de citoyenneté ainsi',
    'qu&#39;un autre document d&#39;identification acceptable. Durant l&#39;appel, assurez-vous de demander quelles pièces',
    'd&#39;identité sont considérées comme étant admissibles afin de bien préparer votre visite. Contactez le service à la',
    'clientèle du permis de conduire amélioré pour vous assurer d&#39;avoir en main les bonnes pièces justificatives avant',
    'votre visite.</li>',
    '<li>Permis de conduire normal : vous devrez vous présenter à un bureau de délivrance de permis de conduire en',
    'vous munissant des documents d&#39;identification requis et payer pour une nouvelle carte et la mise à niveau vers',
    'la carte améliorée.</li>',
    '</ul>',

    '<h6>Alberta</h6>',
    '<ul>',
    '<li>Demandez immédiatement un permis de remplacement gratuit à votre agent des enregistrements le plus près. Vous devrez fournir une pièce d’identité valide.</li>',
    '<li>Contactez le service de police et remplissez un rapport de police. Vous recevrez un numéro de dossier de',
    'rapport de police qui sera consigné dans les registres de l&#39;Alberta.</li>',
    '</ul>',

    '<h6>Saskatchewan</h6>',
    '<ul>',
    '<li>Demandez un nouveau permis moyennant des frais raisonnables en visitant un bureau émetteur de permis de',
    'conduire dans le cas où vous remplacez votre photo.</li>',
    '<li>Si vous conservez votre photo actuelle, vous pouvez vous rendre dans un bureau émetteur de permis de conduire ou encore vous inscrire en ligne sur le site Web MySGI.</li>',
    '</ul>',

    '<h6>Manitoba</h6>',
    '<ul>',
    '<li>Signalez la perte ou le vol de votre permis au <a  href="tel:+1-866-323-0544">1-866-323-0544</a>.</li>',
    '<li>Remplacez-le dès que possible en visitant la concession Autopac ou le centre de service le plus près.</li>',
    '<li>Vous devrez faire prendre votre photo et fournir une autre forme d&#39;identification (p. ex. un certificat de',
    'naissance, une carte d&#39;immatriculation du véhicule, une carte Santé Manitoba, une carte de citoyenneté ou un',
    'passeport).</li>',
    '<li>Une somme modique vous sera exigée au moment du remplacement.</li>',
    '<li>Conservez le permis en papier temporaire qui vous est délivré le jour même, jusqu&#39;à la réception de votre',
    'carte permanente.</li>',
    '</ul>',

    '<h6>Ontario</h6>',
    '<ul>',
    '<li>Demandez immédiatement un nouveau permis dans l&#39;un des points de service de ServiceOntario, moyennant des',
    'frais minimes. Apportez des pièces d&#39;identité portant votre nom, votre date de naissance et votre signature.</li>',
    '<li>Si vous êtes à l&#39;extérieur de l&#39;Ontario au moment de la perte ou du vol, vous pouvez recevoir un permis',
    'temporaire, à condition que votre permis de conduire ne soit pas annulé ou suspendu. Ce permis temporaire n&#39;est',
    'valide que pour une période déterminée. Vous devez donc visiter un point de service ServiceOntario à votre retour',
    'en Ontario afin de le remplacer par un nouveau permis de conduire permanent.</li>',
    '<li>Si vous êtes à l&#39;extérieur de l&#39;Ontario pour plus de 6 mois, vous devez appeler ServiceOntario au',
    '<a  href="tel:416-235-2999">416-235-2999</a> pour connaître les conditions d&#39;admissibilité et d&#39;obtention',
    'd&#39;un nouveau permis.</li>',
    '</ul>',

    '<h6>Québec</h6>',
    '<ul>',
    '<li>Visitez un point de service de la Société de l&#39;assurance automobile du Québec (SAAQ) en ayant en main une',
    'pièce d&#39;identité valide émise par le gouvernement, comme un passeport canadien, un certificat de citoyenneté',
    'canadienne avec photo, une carte d&#39;assurance maladie valide du Québec avec photo, un passeport étranger',
    'accompagné d&#39;une preuve de présence légale connue au Canada, une carte de résident permanent, une carte',
    'd&#39;identité des Forces armées canadiennes ou un certificat du statut d&#39;Indien. Des frais minimes s&#39;appliquent.</li>',
    '<li>Si vous êtes à l&#39;extérieur du Québec au moment de la perte ou du vol, vous pouvez envoyer une demande par',
    'courrier ou par télécopieur pour qu&#39;un permis de conduire sans photo ni signature vous soit envoyé. Une fois',
    'de retour au Québec, vous devrez vous présenter à un point de service pour obtenir un permis avec photo et',
    'signature.</li>',
    '</ul>',

    '<h6>Terre-Neuve-et-Labrador</h6>',
    '<ul>',
    '<li>Présentez une demande en personne, par la poste ou par télécopieur au bureau de la Division de',
    'l&#39;immatriculation des véhicules automobiles le plus près. Indiquez votre numéro de permis de conduire si vous',
    'le connaissez. Sinon, indiquez votre nom, votre adresse et votre date de naissance. Des frais minimes s&#39;appliquent.</li>',
    '</ul>',

    '<h6>Nouveau-Brunswick</h6>',
    '<ul>',
    '<li>Demandez un nouveau permis dans un bureau de Service du Nouveau-Brunswick.</li>',
    '<li>Vous devez présenter :',
    '<ul>',
    '<li>Au moins un document figurant parmi la liste des documents d&#39;identification acceptables (Liste 1)</li>',
    '<li>Au moins deux documents figurant parmi la liste des documents acceptés comme preuve de résidence',
    'au Nouveau-Brunswick (Liste 2)</li>',
    '<li>Une preuve de changement de nom, le cas échéant (c.-à-d. certificat de mariage, documents de divorce',
    'ou certificat de changement de nom).</li>',
    '</ul>',
    '</li>',
    '</ul>',

    '<h6>Nouvelle-Écosse</h6>',
    '<ul>',
    '<li>Demandez un nouveau permis à l&#39;une des succursales du Bureau des véhicules automobiles, moyennant des frais',
    'minimes. Vous devez soumettre le formulaire 1 et des documents d&#39;identification particuliers peuvent être exigés.</li>',
    '</ul>',

    '<h6>Île-du-Prince-Édouard</h6>',
    '<ul>',
    '<li>Si vous perdez votre permis de conduire, vous pouvez en demander une copie en personne dans l&#39;un des',
    'centres Accès Î.-P.-É. Des frais minimes s&#39;appliquent. Les formulaires appropriés doivent être remplis.</li>',
    '<li>Si vous êtes à l&#39;extérieur de la province, appelez au <a  href="tel:902-838-0600">902-838-0600</a> ou',
    'envoyez un courriel à <a  href="mailto:swat@gov.pe.ca">swat@gov.pe.ca</a> pour obtenir de l&#39;aide.</li>',
    '</ul>',

    '<h6>Territoires du Nord-Ouest</h6>',
    '<ul>',
    '<li>Demandez une nouvelle carte en ligne dès que possible. Vous pouvez aussi visiter votre bureau local de',
    'permis de conduire et de véhicule.</li>',
    '<li>Si vous êtes à l&#39;extérieur de la province, vous pouvez communiquer avec la Division de l&#39;immatriculation',
    'et de la sécurité routière du ministère des Transports pour obtenir une lettre de confirmation (vous pourrez',
    'l&#39;utiliser jusqu&#39;à votre retour dans les T-N-O, où vous pourrez alors demander un nouveau permis). Vous',
    'pouvez envoyer votre demande de lettre de confirmation, assortie d&#39;une pièce d&#39;identité avec photo, par',
    'télécopieur au <a  href="tel:+1-867-873-0120">1-867-873-0120</a> ou encore par courriel',
    'à <a  href="mailto:dvlicensing@gov.nt.ca">dvlicensing@gov.nt.ca</a>.</li>',
    '</ul>',

    '<h6>Nunavut</h6>',
    '<ul>',
    '<li>À Iqaluit, à Rankin Inlet, à Cambridge Bay et à Gjoa Haven, vous pouvez obtenir un nouveau permis dans un',
    'bureau d&#39;émission de la Division des véhicules automobiles. Vous pouvez téléphoner sans frais à ces bureaux',
    'au <a tabindex="0" href="tel:+1-888-975-5999">1-888-975-5999</a>.</li>',
    '<li>Dans d&#39;autres communautés, vous pouvez vous adresser au bureau de l&#39;agent de liaison municipal local ou de',
    'l&#39;agent de liaison avec le gouvernement. </li>',
    '<li>Des frais modestes s&#39;appliquent.</li>',
    '<li>Vous devez produire deux pièces d&#39;identité émises par le gouvernement,',
    'dont au moins une indiquant votre date de naissance.</li>',
    '</ul>',

    '<h6>Yukon</h6>',
    '<ul>',
    '<li>Avisez le service de police de la perte de votre permis de conduire.</li>',
    '<li>Demandez un nouveau permis à l&#39;une des succursales du Bureau des véhicules automobiles du Yukon, moyennant des',
    'frais raisonnables.</li>',
    '<li>Un permis de conduire temporaire vous sera délivré jusqu&#39;à ce que vous receviez le nouveau permis par la poste.</li>',
    '<li>Vous devez avoir avec vous les documents originaux comportant votre :',
    '<ul>',
    '<li>Nom légal complet</li>',
    '<li>Date de naissance</li>',
    '<li>Présence légale au Canada</li>',
    '<li>Photo et signature</li>',
    '</ul>',
    '</li>',
    '</ul>'
  ].join('\n')
};
